const siteMetadata = {
  title: 'Carrinho de compras',
  author: 'Rodolfo Wolff',
  headerTitle: 'Minha Loja',
  description: 'Site criado para lojas com carrinho de compras',
  siteUrl: 'https://carinho-de-compras.vercel.app/',
  siteRepo: 'https://github.com/rodolfowolff/carinho-de-compras',
  email: 'rodolfoluizwolff@gmail.com',
  github: 'https://github.com/rodolfowolff',
  linkedin: 'https://www.linkedin.com/in/rodolfowolff',
};

module.exports = siteMetadata;
